import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
export const speedAnimation = 500;

export const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #E5E5E5;
    z-index: 10;
    opacity: ${p => p.show ? '1' : '0'};
    pointer-events: ${p => p.show ? 'auto' : 'none'};
    transition: ${speedAnimation}ms;
    overflow: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    transform: scale(${p => p.show ? '1' : '0'});
    &::-webkit-scrollbar { 
        width: 0;
    }
    @media(max-width: 886px) {
        background-color: ${p => p.bgColor ? p.bgColor : '#E5E5E5'};
    }
    @media(max-width: 530px) {
        -ms-overflow-style: initial;
        overflow: auto;
        &::-webkit-scrollbar { 
            width: initial;
        }
        padding-bottom: 30px;
    }
`;

export const Container = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1500px;
    padding: 0 100px 0 50px;
    @media(max-width: 1620px) {
        padding: 80px 70px 80px 20px;
        max-width: calc(560px +  570px);
    }
    @media(max-width: 1024px) {
        padding: 80px 30px 80px 10px;
    }
    @media(max-width: 886px) {
        flex-direction: column-reverse;
        max-width: 669px;
        padding: 80px 50px;
    }
    @media(max-width: 530px) {
        padding: 40px 18px;
    }
`;

export const Content = styled.div`
  display: block;
  width: 705px;
  padding-left: 79px;
  transition: ${speedAnimation}ms;
  opacity: ${p => p.isVisible ? '1' : '0'};
  transform: translateY(${p => p.isVisible ? '0' : '100px'});
  @media (max-width: 1620px) {
    width: 570px;
    padding-left: 50px;
  }
  @media (max-width: 1024px) {
    width: 520px;
    padding-left: 40px;
  }
  @media (max-width: 886px) {
    padding-left: 0;
    width: 100%;
  }
`;

export const Picture = styled.div`
    display: block;
    position: relative;
    width: calc(100% - 705px);
    transition: ${speedAnimation}ms;
    path {
        transition: ${speedAnimation}ms;
    }
    @media(max-width: 1620px) {
        width: calc(100% - 570px);
    }
    @media(max-width: 1024px) {
        width: calc(100% - 520px);
    }
    @media(max-width: 886px) {
        display: ${p => p.mobile ? 'block' : 'none'};
        width: 100%;
        position: relative;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin-bottom: ${p => p.isShowTariff ? '50px' : '10px'};
    }
`;

export const Svg = styled.svg`
    display: block;
    width: 100%;
    transition: ${speedAnimation}ms;
    transform: scale(${p => p.active ? '1' : '0.5'});
    @media(max-width: 886px) {
      display: none;
    }
`;

export const Image = styled.img`
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    max-width: 68%;
    opacity: ${p => p.active ? '1' : '0'};
    transition: ${speedAnimation}ms;
    transform: scale(${p => p.active ? '1' : '0.5'});
    @media(max-width: 886px) {
        position: ${p => (p.tariff && p.active) ? 'relative' : 'absolute'};
        top: 10px;
        margin: 0 auto;
        z-index: -1;
    }
    @media(max-width: 530px) {
        top: 30px;
        max-width: 100%;
    }
`;

export const Close = styled.div`
    display: block;
    position: absolute;
    top: 60px;
    right: 60px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    transform: rotate(45deg);
    &:after, &:before {
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background-color: ${COLORS.black};
    }
    &:after {
        width: 100%;
        height: 2px;
    }
    &:before {
        width: 2px;
        height: 100%;
    }
    @media(max-width: 1620px) {
        top: 40px;
        right: 40px;
    }
    @media(max-width: 1024px) {
        top: 20px;
        right: 20px;
    }
`;

import ShareInSocial from '../ShareInSocial';

export const Share = styled(ShareInSocial)`
    display: ${p => p.mobile ? 'none' : 'flex'};
    margin-top: 40px;
    @media(max-width: 530px) {
        display: ${p => p.mobile ? 'block' : 'none'};
        margin: -60px 0 30px auto;
    }
`;
